import { BreezeIntelligenceKitProviderNext } from 'breeze-intelligence-kit';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { useState } from 'react';
import { CitationProvider } from '../Citation/useCitation/CitationProvider';
import { SmartPropertyCitationPanel } from '../SmartPropertyCitationPanel';
import { CitationPopoverContent } from './CitationPopoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartPropertyCitationPopover = ({
  smartPropertyResultId,
  open,
  onOpenChange,
  children
}) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [defaultTab, setDefaultTab] = useState('activity');
  const openPanel = tab => {
    setIsPanelOpen(true);
    setDefaultTab(tab);
  };
  return /*#__PURE__*/_jsxs(BreezeIntelligenceKitProviderNext, {
    children: [/*#__PURE__*/_jsx(Popover, {
      closeOnOutsideClick: true,
      closeOnTargetLeave: true,
      content: /*#__PURE__*/_jsx(CitationProvider, {
        smartPropertyResultId: smartPropertyResultId,
        children: /*#__PURE__*/_jsx(CitationPopoverContent, {
          onDetailsClick: () => {
            onOpenChange(syntheticEvent(false));
            openPanel('activity');
          },
          onSourcesClick: () => {
            onOpenChange(syntheticEvent(false));
            openPanel('sources');
          }
        })
      }),
      inlineSize: "360px",
      onOpenChange: onOpenChange,
      open: open,
      use: "longform",
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    }), isPanelOpen && /*#__PURE__*/_jsx(SmartPropertyCitationPanel, {
      onClose: () => setIsPanelOpen(false),
      smartPropertyResultId: smartPropertyResultId,
      defaultTab: defaultTab
    })]
  });
};